<template>
  <div>
    <div v-if="signConfiguration.firma">
      <div
        class="d-flex flex-column align-items-center"
        v-if="signConfiguration.firma.activa !== 'Y'
        && signConfiguration.firma.activa !== 'P'"
      >
        <img
          class="mb-5"
          v-if="signConfiguration.estampa"
          :src="signConfiguration.estampa"
          width=400px
        >
        <br>
        <p class="message-info mb-4">Firma configurada correctamente</p>
        <small>Generando certificado</small>
      </div>
      <div
        class="d-flex flex-column align-items-center"
        v-if="signConfiguration.firma.activa === 'Y'"
      >
        <img
          class="mb-5"
          v-if="signConfiguration.estampa"
          :src="signConfiguration.estampa"
          width=400px
        >
        <br>
        <p class="message-info mb-4">Firma configurada correctamente</p>
        <small>ID Configuración: {{signConfiguration.firma.signerUsuario}}</small>
        <!-- Configuración de estampa -->
        <div class="w-100 mt-4" v-if="$route.name === 'user-profile'">
          <ConfigureStamp
            prefix="esign7"
            proveedor="Esign7"
            tipoFirma="firmaAvanzada"
            :user="user"
          />
        </div>
      </div>
      <div
        v-else-if="signConfiguration.firma.activa === 'P' && $route.name === 'users-management'">
        <h4>
          Firma pendiente de activación, el usuario debe ingresar a su perfil
          para completar el proceso de registro y enrolamiento
        </h4>
      </div>
      <div
        v-else-if="signConfiguration.firma.activa === 'P' && $route.name === 'user-profile'">
        <h5 class="message my-5">
          No cierre sesión o cambie de empresa mientras está en el proceso de enrolamiento
        </h5>
        <VerifyIdentity/>
      </div>
    </div>
    <div v-else>
      <div v-if="$route.name === 'user-profile'">
        <p class="message-info">
          Sin firma configurada dentro de la empresa, cont&aacute;ctese con su administrador
        </p>
      </div>
      <ActivateEnrollment
        v-else
        @signed="$emit('activate')"
        :user="user"
        :signConfiguration="signConfiguration"
      />
    </div>
  </div>
</template>
<script>
import ActivateEnrollment
from '@/febos/global/usuario/components/sign/advanced/eSign/components/ActivateEnrollment';
import VerifyIdentity
from '@/febos/global/usuario/components/sign/advanced/eSign/components/VerifyIdentity';
import ConfigureStamp from '@/febos/global/usuario/components/sign/shared/ConfigureStamp';

export default {
  name: 'AvanzadaSignEsign7',
  components: {
    ActivateEnrollment,
    VerifyIdentity,
    ConfigureStamp
  },
  props: {
    user: { type: Object },
    signConfiguration: { type: Object }
  },
};
</script>

<style scoped>
.message-info {
  color: white;
  width: 500px;
  font-weight: normal;
  background: #ea7037;
  border-radius: 10px 10px 10px 10px;
  padding: 10px;
}
</style>
